export default __webpack_public_path__ + "static/media/i-link.8230dd02.svg";